import { render } from "./App.vue?vue&type=template&id=04da9362&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=04da9362&lang=scss"

import exportComponent from "/Users/tanghuayu/Documents/github/THY161X/huobi-mobile-frontend/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__